import { render } from "./SpinnerLoader.vue?vue&type=template&id=da286fb6"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__